import React from 'react';
import { routes as r } from '../../../routes';
import PersonalData from '../PersonalData';
import ProfileTab from '../ProfileTab';

export const routes = () => ({
  overview: {
    route: r.personalData.route,
    render: () => <PersonalData />,
  },
  profile: {
    route: r.personalDataProfile.route,
    render: () => <ProfileTab />,
  },
});
